export default "__VITE_ASSET__CnNdqAOt__"